import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import TermsConditions from './pages/TermsConditions';
import LegalNotice from './pages/LegalNotice';
import CookieBanner from './components/CookieBanner';
import { initializeConsent, hasConsent, CookieCategories } from './utils/cookieConsent';

function App() {
  const [analyticsEnabled, setAnalyticsEnabled] = React.useState(false);

  useEffect(() => {
    // Initialize cookie consent on app load
    initializeConsent();
    
    // Check if analytics consent is granted
    const checkAnalyticsConsent = () => {
      const enabled = hasConsent(CookieCategories.ANALYTICS);
      setAnalyticsEnabled(enabled);
      console.log('Vercel Analytics enabled:', enabled);
    };
    
    checkAnalyticsConsent();
    
    // Listen for consent changes
    window.addEventListener('cookieConsentChanged', checkAnalyticsConsent);
    
    return () => {
      window.removeEventListener('cookieConsentChanged', checkAnalyticsConsent);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/politica-privacidade" element={<PrivacyPolicy />} />
          <Route path="/politica-cookies" element={<CookiePolicy />} />
          <Route path="/termos-condicoes" element={<TermsConditions />} />
          <Route path="/aviso-legal" element={<LegalNotice />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      {/* Only load Vercel Analytics if user consented */}
      {analyticsEnabled && <Analytics />}
    </div>
  );
}

export default App;